import { GRAY_0 } from './mc-tokens';

export const MODUS_AVATAR_STYLESHEET = `
  .tc-avatar {
    flex-shrink: 0;
    cursor: default;
  }

  .tc-avatar--clickable {
    cursor: pointer;
  }

  modus-wc-avatar .modus-wc-avatar {
    background-color: ${GRAY_0};
  }

  modus-wc-avatar:not([shape="square"]) .modus-wc-avatar,
  modus-wc-avatar[shape="circle"] .modus-wc-avatar {
    border-radius: 50%;
    overflow: hidden;
  }

  modus-wc-avatar:not([shape="square"]) .modus-wc-avatar img,
  modus-wc-avatar[shape="circle"] .modus-wc-avatar img {
    border-radius: 50%;
    object-fit: cover;
  }
`;
